<template>
    <div>
        <div class="col-12 pb-5 mb-4" v-if="pageloader">
            <img src="../../assets/pageloader.svg" class="pageloader" alt="pageloader">
        </div>
        <div v-if="!pageloader">
            <div class="card ml-3 mr-3 mt-lg-2">
                <div class="card-body">
                    <div class="mt-4 pl-3 mb-2">
                        <span class="fontsize14 black stylebold proximanova">Basic Info</span>
                    </div>
                    <div class="form">
                        <div class="row no-gutters">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col mt-1">
                                    <div class="input-group">    
                                        <small class="required small-label">Company Name</small>                                    
                                        <input
                                            type="text"
                                            name="companyName"
                                            data-vv-as="companyName"
                                            class="input-create proximanova"
                                            :class="{'mt-3' :JobObject.isEditJobPage}"
                                            v-model="JobObject.selectedCompany"
                                            autocomplete="off"
                                            v-validate=" 'required' "
                                            data-vv-scope="basicInfo"
                                            required
                                            disabled
                                        />
                                        <span class="bar"></span>
                                        <!-- <label class="label-create required">Company Name</label> -->
                                    </div>
                                </div>
                                <div v-if="errors.has('basicInfo.companyName')" class="alert-danger ml-2">{{ errors.first('basicInfo.companyName') }}</div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col mt-3">
                                    <div class="input-group">
                                        <!-- <select
                                            type="text"
                                            v-validate=" 'required' "
                                            name="jobTitle"
                                            data-vv-as="jobTitle"
                                            data-vv-scope="basicInfo"
                                            class="input-create"
                                            onclick="this.setAttribute('value', this.value);"
                                            v-model="JobObject.jobTitle"
                                            required
                                        >
                                            <option
                                                v-for="(job,index) in jobTitleList"
                                                :value="job.indexDetailName"
                                                :key="index"
                                            >{{job.indexDetailName}}</option>
                                        </select> -->
                                        <small class="required small-label" v-if="JobObject.isEditJobPage">Job Title</small>
                                        <input
                                            type="text"
                                            name="jobTitle"
                                            data-vv-as="jobTitle"
                                            class="input-create proximanova"
                                            v-model="jobTitle"
                                            autocomplete="off"
                                            v-validate=" 'required' "
                                            data-vv-scope="basicInfo"
                                            @keyup="getJobsList"
                                            required
                                            :disabled="JobObject.isEditJobPage"
                                        />
                                        <span class="bar"></span>
                                        <label class="label-create required" v-if="!JobObject.isEditJobPage">Job Title</label>
                                        <div class="dropdown-menu col-12 d-flex" id="companyDropdown" v-if="jobTitleList.length > 0"> 
                                            <div class="proximanova-semibold black60 fontsize12 col-12 pl-0 pr-0 hover">
                                                <li class="list-group-item pl-3" v-for="(jobTitle, index) in jobTitleList" :key="index" @click="selectedJobTitle(jobTitle)">
                                                    {{jobTitle.titleName}}
                                                </li>
                                            </div>
                                        </div> 
                                    </div>
                                    <div v-if="errors.has('basicInfo.jobTitle')" class="alert-danger">{{ errors.first('basicInfo.jobTitle') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col mt-3">
                                    <div class="input-group">
                                        <select
                                            type="text"
                                            v-validate=" 'required' "
                                            name="employmentType"
                                            data-vv-as="employmentType"
                                            data-vv-scope="basicInfo"
                                            class="input-create proximanova"
                                            onclick="this.setAttribute('value', this.value);"
                                            v-model="JobObject.selectedEmploymentType"
                                            @change="onSelectedEmploymentType"
                                            required
                                        >
                                            <option
                                                v-for="(employment,index) in employmentTypesList"
                                                :value="employment.id"
                                                :key="index"
                                            >{{employment.indexDetailName}}</option>
                                        </select>
                                        <span class="bar"></span>
                                        <label class="label-create required">Employment Type</label>
                                    </div>
                                </div>
                                <div v-if="errors.has('basicInfo.employmentType')" class="alert-danger ml-2">{{ errors.first('basicInfo.employmentType') }}</div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col mt-3">
                                    <div class="input-group">
                                        <select
                                            type="text"
                                            v-validate=" 'required' "
                                            name="seniority"
                                            data-vv-as="seniority"
                                            data-vv-scope="basicInfo"
                                            class="input-create proximanova"
                                            onclick="this.setAttribute('value', this.value);"
                                            v-model="JobObject.selecetdSeniority"
                                            @change="onSelectedSeniority"
                                            required
                                        >
                                            <option
                                                v-for="(seniority,index) in seniorityList"
                                                :value="seniority.id"
                                                :key="index"
                                            >{{seniority.indexDetailName}}</option>
                                        </select>
                                        <span class="bar"></span>
                                        <label class="label-create required">Seniority</label>
                                    </div>
                                    <div v-if="errors.has('basicInfo.seniority')" class="alert-danger">{{ errors.first('basicInfo.seniority') }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col mt-3 d-flex">
                                    <div class="input-group col-6 pl-0">
                                        <!-- <select
                                            type="text"
                                            v-validate=" 'required' "
                                            name="pay scale"
                                            data-vv-as="pay scale"
                                            data-vv-scope="basicInfo"
                                            class="input-create proximanova"
                                            onclick="this.setAttribute('value', this.value);"
                                            v-model="JobObject.selectedPayScaleFrom"
                                            required
                                        >
                                            <option
                                                v-for="(pay,index) in payScaleList"
                                                :value="pay.indexDetailName"
                                                :key="index"
                                            >{{pay.indexDetailName}}</option>
                                        </select>
                                        <span class="bar"></span>
                                        <label class="label-create required">Pay Scale</label> -->
                                        <input
                                            type="text"
                                            name="pay scale"
                                            data-vv-as="pay scale"
                                            class="input-create proximanova"
                                            v-model="JobObject.selectedPayScaleFrom"
                                            autocomplete="off"
                                            v-validate=" 'required' "
                                            data-vv-scope="basicInfo"
                                            required
                                        />
                                        <span class="bar"></span>
                                        <label class="label-create required">Pay Scale From</label>
                                    </div>
                                    <div class="mt-4 proximanova font12 black60">To</div>
                                    <div class="input-group col-6 pr-0">
                                        <input
                                            type="text"
                                            name="pay scale"
                                            data-vv-as="pay scale"
                                            class="input-create proximanova"
                                            v-model="JobObject.selectedPayScaleTo"
                                            autocomplete="off"
                                            v-validate=" 'required' "
                                            data-vv-scope="basicInfo"
                                            required
                                        />
                                        <span class="bar"></span>
                                        <label class="label-create required ml-3">Pay Scale To</label>
                                    </div>
                                </div>
                                <div class="fontsize12 proximanova black60 ml-3 mt-1">Note: Please add currency Type after amount in PayScale From and PayScale To</div>
                                <div v-if="errors.has('basicInfo.pay scale')" class="alert-danger ml-2">{{ errors.first('basicInfo.pay scale') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 pl-3 mb-2">
                        <span class="fontsize14 black stylebold proximanova">Location</span>
                    </div>
                    <div class="form mt-4 mb-4">
                        <div class="row no-gutters mt-2">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <small class="required small-label mb-1">Select Country</small>
                                        <multiselect
                                            v-model="JobObject.selectedMultiselectLocCountry"
                                            v-validate=" 'required' "
                                            name="country"
                                            class="multiselect multiselectInput-create proximanova"
                                            :options="countriesList"
                                            label="countryName"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :hide-selected="true"
                                            :preserve-search="true"
                                            track-by="countryId"
                                            @select="onSelectLocCountry"
                                            placeholder="Select Country"
                                            :show-labels="false"
                                            data-vv-as="country"
                                            data-vv-scope="basicInfo"
                                            required>
                                        </multiselect>
                                        <span class="bar"></span>
                                        <center>
                                            <div v-if="errors.has('basicInfo.country') && !JobObject.selectedMultiselectLocCountry" class="alert-danger" >{{ errors.first('basicInfo.country') }}</div>
                                        </center>
                                    </div>
                                    <!-- <div v-if="errors.has('basicInfo.country')" class="alert-danger">{{ errors.first('basicInfo.country') }}</div> -->
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <small class="required small-label mb-1">State</small>
                                        <multiselect
                                            v-model="JobObject.selectedMultiselectLocState"
                                            v-validate=" 'required' "
                                            name="State"
                                            class="multiselect multiselectInput-create proximanova"
                                            :options="statesList"
                                            label="stateName"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :hide-selected="true"
                                            :preserve-search="true"
                                            track-by="stateId"
                                            @select="onSelectLocState"
                                            placeholder="Select State"
                                            :show-labels="false"
                                            data-vv-scope="basicInfo"
                                            data-vv-as="State"
                                            required>
                                        </multiselect>
                                        <span class="bar"></span>
                                        <center>
                                            <div v-if="errors.has('basicInfo.State') && !JobObject.selectedMultiselectLocState" class="alert-danger" >{{ errors.first('basicInfo.State') }}</div>
                                        </center>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row no-gutters mt-2">
                            <div class="col-lg-6 col-md-6 col-sm-12">
                                <div class="col">
                                    <div class="input-group mb-3">
                                        <small class="required small-label mb-1">City</small>
                                        <multiselect
                                            v-model="JobObject.selectedMultiselectLocCity"
                                            v-validate=" 'required' "
                                            name="city"
                                            class="multiselect multiselectInput-create proximanova"
                                            :options="citiesList"
                                            label="cityName"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :hide-selected="true"
                                            :preserve-search="true"
                                            track-by="cityId"
                                            @select="onSelectLocCity"
                                            placeholder="Select City"
                                            :show-labels="false"
                                            data-vv-scope="basicInfo"
                                            data-vv-as="city"
                                            required>
                                        </multiselect>
                                        <span class="bar"></span>
                                        <center>
                                            <div v-if="errors.has('basicInfo.city') && !JobObject.selectedMultiselectLocCity" class="alert-danger">{{ errors.first('basicInfo.city') }}</div>
                                        </center>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-12 mt-2">
                                <div class="col">
                                    <div class="input-group mt-2">
                                        <input
                                            type="text"
                                            name="Pin Code"
                                            data-vv-scope="basicInfo"
                                            v-validate="{ required:true, regex: /^(?!0+$)[0-9]{4,10}$/ }"
                                            data-vv-as="Pin Code"
                                            class="input-create proximanova"
                                            autocomplete="off"
                                            v-model="JobObject.pinCode"
                                            maxlength="10"
                                            required
                                        />
                                        <span class="bar"></span>
                                        <label class="label-create required">Pin Code</label>
                                        <center>
                                            <div v-if="errors.has('basicInfo.Pin Code')" class="alert-danger">{{ errors.first('basicInfo.Pin Code') }}</div>
                                        </center>
                                    </div>
                                    <!-- <div class="input-group mt-2" v-if="country == 1">
                                        <input
                                            type="text"
                                            name="Pin Code"
                                            data-vv-scope="basicInfo"
                                            v-validate="{ required:true, regex:/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/, digits:6 }"
                                            data-vv-as="Pin Code"
                                            class="input-create proximanova"
                                            autocomplete="off"
                                            v-model="JobObject.pinCode"
                                            @keyup="validateBasicInfo"
                                            maxlength="6"
                                            required
                                        />
                                        <span class="bar"></span>
                                        <label class="label-create required">Pin Code</label>
                                        <center>
                                            <div v-if="errors.has('basicInfo.Pin Code')" class="alert-danger">{{ errors.first('basicInfo.Pin Code') }}</div>
                                        </center>
                                    </div>
                                    <div class="input-group mt-1"  v-if="country == 2">
                                        <input
                                            type="text"
                                            name="Zip Code"
                                            v-validate="{  required:true, regex: /^(\d)(?!\1+$)/, digits:5 }"
                                            data-vv-as="Zip Code"
                                            class="input-create proximanova"
                                            data-vv-scope="basicInfo"
                                            autocomplete="off"
                                            @keyup="validateBasicInfo"
                                            v-model="JobObject.pinCode"
                                            maxlength="5"
                                            required
                                        />
                                        <span class="bar"></span>
                                        <label class="label-create required">Zip Code</label>
                                        <center>
                                            <div v-if="errors.has('basicInfo.Zip Code')" class="alert-danger">{{ errors.first('basicInfo.Zip Code') }}</div>
                                        </center>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card ml-md-3 mr-3 mb-4 mt-4 ">
                <div class="row no-gutters mb-3">
                    <div class="col ml-3 mt-3">
                        <label class="very-low ml-2 mr-2 proximanova">Add benefits</label>
                        <img  src="../../assets/Info.svg" alt="info" class="img-fluid red-tooltip" data-toggle="tooltip" data-placement="bottom" data-original-title="Benefits"/>
                    </div>
                </div>
                <div v-for="(benefit, index) in JobObject.companyBenefitsList" :key="index" class="col-11 ml-3 mb-2">
                    <div class="border-0 backgroundcolor2 card p-3 borderadius12">
                        <div class="d-flex">
                            <div>
                                <img src="../../assets/Profile_placehlder.svg" class="img-fluid" alt="benefitlogo">
                            </div>
                            <div class="d-flex flex-column ml-3 mr-auto">
                                <span class="fontsize16 black proximanova">{{benefit.benefitType}}</span>
                                <span class="fontsize14 black60 proximanova">{{benefit.benefitDescription}}</span>
                            </div>
                            <!-- <div class="justify-content-end pl-1 mr-3 d-flex" @click="editBenefit(benefit, index)">
                                <img src="../../assets/Edit.svg" class="img-fluid mr-md-1" width="28px" />
                                <label class="mr-3 fontsize14 stylebold proximanova my-auto pointer d-none d-md-block">Edit</label>
                            </div> -->
                            <div class="justify-content-end pl-1 mr-3 d-flex" @click="deleteBenefitModalOpen(index)" data-toggle="modal" data-target="#deleteBenefitpModal">
                                <img src="../../assets/Deleteall.svg" alt="delete" width="28px" class="img-fluid deleteIcon mr-1">
                                <label class="mr-3 fontsize14 stylebold proximanova pointer my-auto d-none d-md-block">Delete</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form mt-2">
                    <div class="row no-gutters ml-1 p-2">
                        <div class="col-lg-6">
                            <div class="col">
                                <div class="input-group">
                                    <small class="small-label mb-2">Type</small>
                                    <multiselect v-model="selectedCompanyBenefit" v-validate=" 'required' "
                                        name="industry"
                                        class="multiselect multiselectInput-create proximanova"
                                        :options="benefitsTypesList"
                                        label="indexDetailName"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :hide-selected="true"
                                        :preserve-search="true"
                                        track-by="id"
                                        @select="onSeletBenefitType"
                                        placeholder="Select Benefit Type"
                                        :show-labels="false"
                                        required>
                                    </multiselect>
                                    <span class="bar"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row no-gutters ml-1 p-2">
                        <div class="col d-flex justify-content-start align-items-center  ml-3">
                            <div class="form-group">
                                <label for="companyBenefitsDescriptionTextarea" class="small-label">Benefits</label>
                                <div class="d-flex proximanova">(<p id="charactersRemaining">400</p><p>/400 )</p></div>
                                <textarea class="form-control proximanova" v-model="CompanyBenefitsDescription" id="companyBenefitsDescriptionTextarea"
                                    @keyup="countRemainingCharacters()"
                                    rows="3"
                                    cols="77"
                                    spellcheck="true"
                                    maxlength="400"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 p-3">
                            <div class="float-right">
                                <button class="mr-3 btn button-cancel11 borderradius20 navtoPage" @click="clearBenefitData">
                                    <span class="proximanova">Cancel</span>
                                </button>
                                <button class="mr-3 btn button-create borderradius20 sign-up-button" id="finalsubmitbtn"  :disabled='submitbtnDisabled' @click="addCompanyBenefits">
                                    <span class="button-cancel-font proximanova" >Add</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- confirm modal view to delete benefits -->
            <div class="modal fade" id="deleteBenefitpModal" tabindex="-1" role="dialog" aria-labelledby="deleteExpModalLabel" aria-hidden="true">
                <div class="modal-dialog " role="document">
                    <div class="modal-content">
                        <div class="modal-header delete-modal">
                            <h5 class="modal-title fontsize20 black80 proximanova" id="deleteExpModalLabel">Are you sure you want to delete this record ?</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="clearBenefitData">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body modal-delete text-center">
                            <span class="btn button-cancel11 mr-2 pr-4 borderradius20 pl-4 navtoPage proximanova" data-dismiss="modal" aria-label="Close" >No</span>
                            <span class="btn sign-up-button blackbackhroundsignin borderradius20 fontsizemd pr-4 pl-4 pointer proximanova" @click="deleteBenefit">Yes</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card ml-3 mr-3 mb-4 p-4">
                <div class="d-lg-flex d-md-flex justify-content-between">
                    <div class="d-flex flex-column">
                        <span class="fontsize12 black60 proximanova">By continuing, you agree with</span>
                        <span class="fontsize12 stylebold black60 proximanova">Worknotion <a :href="wndata.termsandConditions" target="_blank" rel="noopener noreferrer" class="proximanova blue pointer">Terms & Conditions</a> </span>
                    </div>
                    <div class="d-flex justify-content-end btnsection">
                        <button class="btn mr-2 fontsizemd navtoPage borderradius20 proximanova" :disabled="saveasDraftBtnClicked" @click="openCancelModal">Cancel</button>
                        <img src="../../assets/uploadvideo.svg" alt="uploading" width="32px" class="img-fluid ml-2 mr-2" v-if="saveasDraftBtnClicked">
                        <button class="btn button-cancel11 mr-2 borderradius20 navtoPage proximanova" v-if="!saveasDraftBtnClicked" @click="saveAsaDraft">Draft</button>
                        <button class="btn sign-up-button borderradius20 fontsizemd proximanova blackbackhroundsignin" :disabled="saveasDraftBtnClicked" id="basicinfo" @click="moveToJobDetailsSecttion">Continue</button>
                    </div>
                </div>
            </div>
            <cancel-modal v-if="showcancelModal" :JobObject="JobObject" @closeCancelModal="closeCancelModal"></cancel-modal>
            <APIErrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIErrorModal>
        </div>
    </div>
</template>
<script>
import { bus } from "@/main.js";
import cancelModal from './cancelModal.vue'
import htttpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js"
import httpbusiness from "@/js/http-business.js";
import APIErrorModal from '../../components/APIerrorpopup.vue'
import router from '../../router.js'
import sessionUtils from "@/js/session-util.js";
import wndata from '@/js/wn_data.json'
import $ from 'jquery'
export default {
    data() {
        return{
            pageloader : false,
            //basic info section
            companyProfileId : null,
            companiesList : [],
            jobTitleList : [],
            employmentTypesList : [],
            seniorityList : [],
            payScaleList : [],
            countriesList : [],
            // selectedMultiselectLocCountry : null,
            statesList : [],
            // selectedMultiselectLocState : null,
            citiesList : [],
            // selectedMultiselectLocCity : null,
            selectedCompany : '',
            jobTitle : '',
            selectedEmploymentType : '',
            selecetdSeniority : '',
            selectedPayScale : '',
            country : null,
            state : null,
            city : null,
            //benefits section
            submitbtnDisabled : true,
            companyBenefitsList : [],
            benefitsTypesList : [],
            selectedBenefitIndex : null,
            selectedCompanyBenefit : null,
            selectedBenefit : null,
            CompanyBenefitsDescription : '',
            deleteBenefitIndex : null,
            //cancel modal
            showcancelModal : false,
            basicInfoDisable : true,
            saveasDraftBtnClicked : false,
            displayAPIerrorModal : false,
            //json
            wndata : {},
        }
    },
    components : {
        cancelModal,
        APIErrorModal
    },
    props : [
        'JobObject'
    ],
    mounted() {
        console.log("job object : ", this.JobObject)
        this.companyProfileId = sessionUtils.getCompanyProfileId();
        this.jobTitle = this.JobObject.jobTitle;
        this.country = this.JobObject.country;
        this.wndata = wndata;
        window.scrollTo(0, 0)
        this.getCountriesList()
        this.getBenefitsTypesList()
        this.getEmploymentTypesList()
        this.getSeniorityList()
        if(this.JobObject.isEditJobPage){
            // this.selectedMultiselectLocCountry = this.JobObject.selectedCountry;
            // this.selectedMultiselectLocState = this.JobObject.selectedState;
            // this.selectedMultiselectLocCity = this.JobObject.selectedCity;
            this.country = this.JobObject.country
            this.getStatesList()
        }else if(!this.JobObject.isEditJobPage && !this.JobObject.isBasicInfoCompleted){
            console.log("get company benefits list")
            this.getCompanyBenefitsList()
        }
        
    },
    methods:{
        closeAPIerrorModal(){
          this.displayAPIerrorModal = false;
        },
        //fetch benefits types list (for drop down)
        getBenefitsTypesList() {
            httpjob.get('/postjob/getListOfIndexDetails?indexcode=15')
            .then((response) => {
                this.benefitsTypesList = response.data
                console.log(this.benefitsTypesList)
                console.log(this.JobObject.selectedEmploymentType)
            }).catch((e) => {
                console.log(e)
            })
        },
        //fetch employment types list
        getEmploymentTypesList(){
            httpjob.get('/postjob/getListOfIndexDetails?indexcode=2')
            .then((response) => {
                this.employmentTypesList = response.data
                console.log(this.employmentTypesList)
            }).catch((e) => {
                console.log(e)
            })
        },
        //fetch seniority types list
        getSeniorityList(){
            httpjob.get('/postjob/getListOfIndexDetails?indexcode=17')
            .then((response) => {
                this.seniorityList = response.data
                console.log(this.seniorityList)
            }).catch((e) => {
                console.log(e)
            })
        },
        validateBasicInfo(){
            this.jobTitleList = [];
            this.$validator.validateAll("basicInfo").then((isValid) => {
                if(isValid){
                    this.basicInfoDisable = false;
                    console.log("valid")
                    document.getElementById("basicinfo").classList.add("blackbackhroundsignin");
                } else{
                    this.basicInfoDisable = true;
                    console.log("not valid")
                    document.getElementById("basicinfo").classList.remove("blackbackhroundsignin");
                }
            })
        },
        // fetching the job names list based on text enter in job title input filed
        getJobsList(){
            this.JobObject.titleId = null;
            this.JobObject.jobTitle = this.jobTitle;
            this.jobTitleList = [];
            if((this.jobTitle).length >= 3)
            httpjob.get('/postjob/getJobTitleBySearchText?searchText='+this.jobTitle)
            .then((response) => {
                this.jobTitleList = response.data
                console.log(this.jobTitleList)
            }).catch((e) => {
                console.log(e)
            })
            //this.validateBasicInfo()
        },
        // this will invoke after change the employment dropdown to display the value while preview
        onSelectedEmploymentType(){
            for(var i =0; i < this.employmentTypesList.length; i++){
                if(this.employmentTypesList[i].id === this.JobObject.selectedEmploymentType){
                    this.JobObject.selectedEmployemntTypeName = this.employmentTypesList[i].indexDetailName
                    console.log(this.JobObject.selectedEmployemntTypeName)
                }
            }
            //this.validateBasicInfo()
        },
        // this will invoke after change the seniority dropdown to display the value while preview
        onSelectedSeniority(){
            for(var i =0; i < this.seniorityList.length; i++){
                if(this.seniorityList[i].id === this.JobObject.selecetdSeniority){
                    this.JobObject.selectedSeniorityTypeName = this.seniorityList[i].indexDetailName
                    console.log(this.JobObject.selectedSeniorityTypeName)
                }
            }
            //this.validateBasicInfo()
        },
        // initial rendering company benefits data
        getCompanyBenefitsList() {
            httpjob.get('/postjob/getCompanyBenifits?companyProfileId='+this.JobObject.companyProfileId)
            .then((response) => {
                // this.JobObject.companyBenefitsList = response.data;
                console.log("company benefits : ", response)
                let companybenefitsList = response.data;
                if(companybenefitsList.length > 0){
                    for(var i=0; i< companybenefitsList.length; i++){
                        let obj = {
                            benefit_id : null,
                            benefitType : companybenefitsList[i].type,
                            benefitDescription : companybenefitsList[i].benifits,
                            creationUserI: this.JobObject.emailId
                        }
                        this.JobObject.companyBenefitsList.push(obj)
                    }
                }
            }).catch((e) => {
                console.log(e)
            })
        },
        selectedJobTitle(job) {
            this.JobObject.titleId = job.title_id;
            this.JobObject.jobTitle = job.titleName;
            this.jobTitle = job.titleName;
            this.jobTitleList = []
            //this.validateBasicInfo()
        },
        // this will invoke after click on draft button 
        // to save data as draft
        saveAsaDraft() {
            var vm = this;
            this.$validator.validateAll("basicInfo").then((isValid) => {
                if(isValid){
            this.saveasDraftBtnClicked = true;
            let finalObj = {
                jobId : this.JobObject.jobId,
                companyProfileId : this.JobObject.companyProfileId,
                employeeId : this.JobObject.employeeId,
                employmentTypeId : this.JobObject.selectedEmploymentType,
                titleId : this.JobObject.titleId,
                jobTitle : this.JobObject.jobTitle,
                jobDesc : this.JobObject.jobDescription,
                seniorityId : this.JobObject.selecetdSeniority,
                jobStatus : 'DRAFT',
                payScaleFrom : this.JobObject.selectedPayScaleFrom,
                payScaleTo : this.JobObject.selectedPayScaleTo,
                countryId : this.JobObject.country,
                stateId : this.JobObject.state,
                cityId : this.JobObject.city,
                zipcode : this.JobObject.pinCode,
                companyBenefitsList : this.JobObject.companyBenefitsList,
                addedSkillsList : this.JobObject.addedSkillsList,
                communicationType : this.JobObject.communicationType,
                emailId : this.JobObject.emailId,
                jobActive : 'ACTIVE',
                screeningQuestionsList : this.JobObject.screeningQuestionsList,
                jobPostedBy : this.JobObject.jobPostedBy
            }
            console.log("final job object for draft: ", finalObj)
            httpjob.post('/postjob/PostingUserInfo', finalObj)
            .then((response) => {
                console.log(response)
                this.saveasDraftBtnClicked = false;
                vm.$toast.success("successfully saved as draft")
                router.push({
                    name : 'draftJobs'
                })
            }).catch((e) => {
                console.log(e.response)
                this.saveasDraftBtnClicked = false;
                this.displayAPIerrorModal = true;
            })
                }
            })
        },
        //this will invoke after click on cancel button to open cancel model
        openCancelModal() {
            this.$validator.validateAll("basicInfo").then((isValid) => {
                if(isValid){
            this.showcancelModal = true;
                }
            })
        },
        //this will invoke after click on close button in cancel modal component
        closeCancelModal(statusObj) {
            console.log(statusObj)
            this.showcancelModal = false;
        },
        //this will invoke after click on continue button
        moveToJobDetailsSecttion : function() {
            this.$validator.validateAll("basicInfo").then((isValid) => {
                if(isValid){
            this.JobObject.isBasicInfoCompleted = true;
            bus.$emit('moveToNext', 'jobDetails');
                }
            })

        },
        //this will invoke while loading the component
        getCountriesList(){
            httpjob.get("postjob/getCountriesList")
            .then(response => {
                this.countriesList = response.data;
                console.log(response.data);
            }).catch((e) => {
                console.log(e)
            })
        },
        //this will invoke after selecting a country from dropdown
        //fetch stateslist based on country
        onSelectLocCountry : function(option){
            this.country = option.countryId;
            this.JobObject.country = option.countryId;
            this.JobObject.selectedMultiselectLocCountry = option;
            //clear selected states if change the country and get statesList
            this.JobObject.selectedMultiselectLocState = null;
            this.JobObject.selectedMultiselectLocCity = null;
            this.JobObject.pinCode = null;
            this.state = null;
            this.statesList = []
            this.getStatesList()
            //this.validateBasicInfo()
        },
        //this.will invoke after selecting a country from dropdown
        getStatesList() {
            httpjob.get("postjob/getStatesList", {
                params: { countryCode: this.country }
            })
            .then(response => {
                this.statesList = response.data;
                console.log(response.data);
            }).catch((e) => {
                console.log(e)
            })
        },
        //this will invoke after selecting a state from dropdown
        //fetch cities list based on state selection
        onSelectLocState : function(option) {
            this.state = option.stateId;
            this.JobObject.state = option.stateId;
            this.JobObject.selectedMultiselectLocState = option;
            //clear selected cities if change the state and get cities List
            this.JobObject.selectedMultiselectLocCity = null;
            this.JobObject.pinCode = null;
            this.city = null;
            this.citiesList = [];
            this.getCitiesList()
            // console.log(option)
            //this.validateBasicInfo()
        },
        //this will invoke after selecting state from dropdown
        getCitiesList(){
            httpjob.get("postjob/getCitiesList", {
                params: { stateCode: this.state }
            }).then(response => {
                this.citiesList = response.data;
                console.log(response.data);
            }).catch((e) => {
                console.log(e)
            })
        },
        onSelectLocCity : function(option) {
            this.city = option.cityId;
            this.JobObject.city = option.cityId;
            this.JobObject.selectedMultiselectLocCity = option;
            this.JobObject.pinCode = null;
            // console.log(option)
            //this.validateBasicInfo()
        },
        //this will invoke when click on edit button of any benefit in benefits list
        editBenefit(benefit, index){
            console.log(benefit)
            this.selectedBenefitIndex = index;
            this.selectedCompanyBenefit = {indexDetailName : benefit.benefitType};
            this.selectedBenefit = benefit.benefitType;
            this.CompanyBenefitsDescription = benefit.benefitDescription
            //update remaining characters count
            document.getElementById('companyBenefitsDescriptionTextarea').value = this.CompanyBenefitsDescription
            this.countRemainingCharacters()
        },
        deleteBenefitModalOpen(index){
            this.deleteBenefitIndex = index
        },
        deleteBenefit  :function(){
            this.JobObject.companyBenefitsList.splice(this.deleteBenefitIndex, 1)
            $('#deleteBenefitpModal').modal('hide')
            this.clearBenefitData()
        },
        // this will invoke when select benefit from dropdown list
        onSeletBenefitType(option) {
            this.selectedBenefit = option.indexDetailName;
            this.benefitsValidation()
        },
        
        // this event represent the validation for the input fileds and enable and disable submit button.
        // this will invoke after fill each input field
        benefitsValidation(){
            if(this.selectedBenefit !== null && this.CompanyBenefitsDescription !== ''){
                document.getElementById('finalsubmitbtn').classList.add('blackbackhroundsignin')
                this.submitbtnDisabled = false;
            }else{
                document.getElementById('finalsubmitbtn').classList.remove('blackbackhroundsignin');
                this.submitbtnDisabled = true
            }
        },
        // this event will invoke for every keyup in benefits description text area
        countRemainingCharacters() {
            var textEntered, countRemaining, counter;
            textEntered = document.getElementById('companyBenefitsDescriptionTextarea').value;
            counter = (400 - (textEntered.length));
            countRemaining = document.getElementById('charactersRemaining');
            countRemaining.textContent = counter;
            this.benefitsValidation()
        },
        clearBenefitData(){
            console.log("clear benefit")
            this.selectedCompanyBenefit = null;
            this.CompanyBenefitsDescription = null;
            this.selectedBenefitIndex = null;
            this.deleteBenefitIndex = null;
        },
        addCompanyBenefits() {
            console.log("add benefit")
            if(this.selectedBenefitIndex === null){
                let obj = {
                    benefitId : null,
                    benefitType : this.selectedCompanyBenefit.indexDetailName,
                    benefitDescription : this.CompanyBenefitsDescription,
                    creationUserI: this.JobObject.emailId,
                    updatedUserI: this.JobObject.emailId 
                }
                this.JobObject.companyBenefitsList.push(obj)
            }else{
                if(this.JobObject.companyBenefitsList[this.selectedBenefitIndex].benefitId !== null){
                    this.JobObject.companyBenefitsList[this.selectedBenefitIndex].benefitType = this.selectedCompanyBenefit.indexDetailName;
                    this.JobObject.companyBenefitsList[this.selectedBenefitIndex].benefitDescription = this.CompanyBenefitsDescription;
                }else{
                    this.JobObject.companyBenefitsList[this.selectedBenefitIndex].benefitId = null;
                    this.JobObject.companyBenefitsList[this.selectedBenefitIndex].benefitType = this.selectedCompanyBenefit.indexDetailName;
                    this.JobObject.companyBenefitsList[this.selectedBenefitIndex].benefitDescription = this.CompanyBenefitsDescription;
                }
            }
            this.clearBenefitData()
        }
    },
}
</script>
<style scoped>
@import '../../css/vue-multiselect.min.css';
@import '../../css/vue2-datepicker.css';
.nav-link {
  padding: 0px 0px 0px 0px;
}
.nav-tabs {
  border-bottom: none !important;
}
.card-header {
  padding: 0px 0px 3px 0px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.card-header {
  border-radius: 8px !important;
}
.profile-pic {
	position: relative;
	display: inline-block;
}
.profile-border{
  padding: 2px;
  border: 2px solid #ced4da;
  border-radius: 50%;
}
.edit {
  cursor: pointer;
  border: 1px solid rgba(31, 31, 31, .1);
  border-radius: 50%;
	position: absolute;
	right: 0;
	top: 0;
  margin-top:70%
}
.mouseoveraction:hover{
	background-color: rgba(161, 166, 179,.2);
  border-radius: 8px;
}
.border-tab {
  border-bottom-style: solid;
  border-bottom-color: #0078ff;
}
.list-text-color {
  color: #0078FF ;
  font-family: "Proxima Nova";
  font-weight: bold;
  letter-spacing: 0;
}
.dropdown-menu{
    display:block;    
    color: black;
    box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
    border: none;
    /* min-width:100%; */
    margin-top: 0px;   
    border-radius: 10px  !important;
}
.list-group-item{
    padding: .25rem 0.25rem;
    border: none;
    cursor: pointer;
}
.list-group-item:hover{
    background: rgba(31, 31, 31, .1);
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
nav ul li a {
  padding: 0.5rem 0.9rem;
}
.nameblock {
  padding-left: 0 !important;
}
/* form styles */
.input-create {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
  
}
.input-create:focus{
/* .input-create:valid { */
  outline: none;
  border-bottom: 1px solid #0078FF;
}
.multiselectInput-create {
  font-size: 18px;
  padding: 0 0 0 0;
  display: block;
  width: 100%;
  border: none;
  /* border-bottom: 1px solid #757575; */
}
.multiselectInput-create:hover {
  border-bottom: 1px solid #0078FF !important;
}

/* LABEL ======================================= */
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 20px;
  font-family: "ProximaNova-Regular" !important;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}

/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -15px;
  font-size: 14px;
  /* color: #0078FF; */
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 14px !important;
	position: relative;
	z-index : 1;
}
/* modal styles */
.modal{
    margin-top: 15%;
}
.modal-delete {
  background-color: white;
  border-radius: .3rem;
  padding-top: 0 !important;
}
.delete-modal{
  border: none;
}
@media only screen and (max-width: 600px) {
  .pageloader {
    width: 20%;
    margin-top: 25%;
    margin-left: 40%;
  }
  .btnsection{
      margin-top: 10px !important;
  }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5% !important;
    padding-right: 5% !important;
  }
}
</style>
